{
  "version": "1.2.6",
  "objects": {
    "7447613635127887394": {
      "type": "frame",
      "id": "7447613635127887394",
      "z": 8394,
      "textContent": "",
      "left": 6727.97239280506,
      "top": 359.2446611448529,
      "width": 400,
      "height": 500,
      "scaleX": 1.384100228620491,
      "scaleY": 0.891472178563729,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a2V",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 30,
      "layoutPadding": 100,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7447613635137981359": {
      "type": "wireframe",
      "id": "7447613635137981359",
      "z": 7714,
      "top": 392.1127057857851,
      "left": 6749.176013055689,
      "width": 511.2328509469389,
      "height": 40,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7447613635127887394",
      "layoutPosition": "a0",
      "wireframeName": "navMenuHorizontal",
      "fill": "#0CB4B4",
      "itemsData": {
        "7447576634676878057": {
          "id": "7447576634676878057",
          "state": "default",
          "value": "Step 1",
          "iconLeft": { "prefix": "fas", "iconName": "circle-check" },
          "item_position": 0
        },
        "7447576634676934272": {
          "id": "7447576634676934272",
          "state": "selected",
          "value": "Step title     ",
          "iconLeft": { "prefix": "fas", "iconName": "2" },
          "item_position": 1000000
        },
        "7447576634677188844": {
          "id": "7447576634677188844",
          "value": "Step title",
          "iconLeft": { "prefix": "fas", "iconName": "3" },
          "item_position": 2000000
        },
        "7447576663231727641": {
          "id": "7447576663231727641",
          "value": "Step title",
          "iconLeft": { "prefix": "fas", "iconName": "4" },
          "item_position": 3000000
        }
      },
      "textColor": "#333333",
      "fontSize": 14,
      "label": {},
      "placeholder": {},
      "setDimension": true,
      "layout": "row",
      "showIcons": true,
      "showSeparators": true
    },
    "7447613635141858504": {
      "type": "shape",
      "id": "7447613635141858504",
      "z": 7734,
      "shapeName": "text",
      "textContent": "<p>Paragraph text</p>",
      "left": 6769.29767949051,
      "top": 462.1127057857851,
      "width": 546.6406581089079,
      "height": 30.17616436317187,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.8616071839710477,
      "scaleY": 0.8616071839710477,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 0.4,
      "textAlign": "left",
      "fontSize": 12.062500575594669,
      "angle": 0,
      "container": "7447613635127887394",
      "authorId": "7114817504471034116",
      "showAuthor": true,
      "layoutPosition": "a1",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7447613635126457511": {
      "type": "wireframe",
      "id": "7447613635126457511",
      "z": 7744,
      "top": 518.1127057857851,
      "left": 6768.500935930021,
      "width": 472.5830051982739,
      "height": 40,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7447613635127887394",
      "layoutPosition": "a2",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#7E7B7B",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Email", "position": "noLabel" },
      "placeholder": {
        "state": "text",
        "value": "Name",
        "iconLeft": { "prefix": "fas", "iconName": "user" },
        "iconRight": null
      },
      "setDimension": true
    },
    "7447613635137354886": {
      "type": "wireframe",
      "id": "7447613635137354886",
      "z": 7754,
      "top": 588.1127057857851,
      "left": 6768.925846041307,
      "width": 471.7331849757029,
      "height": 40,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7447613635127887394",
      "layoutPosition": "a3",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#7E7B7B",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Password", "position": "noLabel" },
      "placeholder": {
        "state": "text",
        "value": "Email",
        "iconLeft": { "prefix": "fas", "iconName": "envelope" },
        "iconRight": null
      },
      "setDimension": true
    },
    "7447613635141633873": {
      "type": "wireframe",
      "id": "7447613635141633873",
      "z": 7764,
      "top": 658.1127057857851,
      "left": 6768.925846041307,
      "width": 471.7331849757029,
      "height": 40,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7447613635127887394",
      "layoutPosition": "a4",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#7E7B7B",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Password", "position": "noLabel" },
      "placeholder": {
        "state": "text",
        "value": "Phone number",
        "iconLeft": { "prefix": "fas", "iconName": "phone-flip" },
        "iconRight": null
      },
      "setDimension": true
    },
    "7447613635130265652": {
      "type": "frame",
      "id": "7447613635130265652",
      "z": 7774,
      "textContent": "Frame 20",
      "left": 6768.218391198959,
      "top": 728.1127057857851,
      "width": 400,
      "height": 500,
      "scaleX": 1.1828702366509969,
      "scaleY": 0.08,
      "fill": "transparent",
      "opacity": 1,
      "container": "7447613635127887394",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a6",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "children",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7447613635128560703": {
      "type": "wireframe",
      "id": "7447613635128560703",
      "z": 6220,
      "top": 728.6127057857851,
      "left": 6768.218391198959,
      "width": 81.1240234375,
      "height": 40,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7447613635130265652",
      "wireframeName": "button",
      "fill": "#B6B6B6",
      "textColor": null,
      "style": "square",
      "fontSize": 14,
      "label": {},
      "placeholder": {
        "state": "default",
        "value": "Back",
        "iconLeft": { "prefix": "fas", "iconName": "arrow-left" },
        "iconRight": null
      }
    },
    "7447613635138775593": {
      "type": "wireframe",
      "id": "7447613635138775593",
      "z": 6221,
      "top": 728.6127057857851,
      "left": 7160.580353046857,
      "width": 78.7861328125,
      "height": 40,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7447613635130265652",
      "layoutPosition": "a0",
      "wireframeName": "button",
      "fill": "#0CB4B4",
      "textColor": null,
      "style": "squareFilled",
      "fontSize": 14,
      "label": {},
      "placeholder": {
        "state": "default",
        "value": "Next",
        "iconLeft": null,
        "iconRight": { "prefix": "fas", "iconName": "arrow-right" }
      }
    }
  }
}
